import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
import { PromoCodeProps } from '../../Summary.definitions';
import { Form } from '~/shared/components/form/components/form/form';
import { Button } from '~/shared/components/Button/Button';
import { useTranslation } from '~/shared/utils/translation';
import { InputPromo } from './styled';

export const PromoCodeForm = forwardRef(
    (
        { onSubmit, submitLabel, name }: Pick<PromoCodeProps, 'onSubmit' | 'name' | 'submitLabel'>,
        ref,
    ) => {
        const { translate } = useTranslation();
        const methods = useForm({
            mode: 'onChange',
        });

        useImperativeHandle(ref, () => ({
            reset: () => {
                methods.reset({ [name]: '' });
            },
        }));

        return (
            <Form methods={methods} onSubmit={onSubmit}>
                <InputPromo
                    type="text"
                    rules={{
                        minLength: 3,
                        required: true,
                    }}
                    name={name}
                    placeholder={translate('checkout.promoSection.placeholder')}
                    append={
                        <Button type="submit" disabled={!methods.formState.isValid}>
                            {submitLabel}
                        </Button>
                    }
                ></InputPromo>
            </Form>
        );
    },
);
